export default __webpack_public_path__ + "static/media/6.444559c8.jpg";